import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Col } from "react-bootstrap";
import {
  Home,
  BarChart3,
  Search,
  RotateCcw,
  Users,
  BookOpen,
  Upload,
  Clock,
  Shield,
  CreditCard,
  Plane,
  MessageSquare,
  CheckSquare,
  FileText,
  Palette,
  Edit3,
  Package,
  Key,
  ChevronLeft,
  ChevronRight,
  ArrowLeft,
  UserCheck,
  Tags,
  QrCode,
  CalendarDays,
  ShieldCheck
} from "lucide-react";
import "./LeftPanel.css";
import { isTeacher } from "../utils/auth";

function LeftPanel() {
  const location = useLocation();
  const [activeItem, setActiveItem] = useState(location.pathname);
  const [isCollapsed, setIsCollapsed] = useState(false);
  
  const teacherMode = isTeacher();

  const handleReturnToTD = (event) => {
    event.preventDefault();
    const tdAdminUrl = process.env.REACT_APP_TD_ADMIN_DASHBOARD || `${process.env.REACT_APP_TD_URL}/admindashboard`;
    console.log('ðŸ”™ Returning to TD Admin Dashboard:', tdAdminUrl);

    localStorage.removeItem('source_app');
    localStorage.removeItem('teacher_school_id');

    window.location.href = tdAdminUrl;
  };

  const teacherNavItems = [
    { to: "/masterdashboard", label: "Home", icon: Home, color: "#3b82f6" },
  ];

  const allNavItems = [
    { to: "/masterdashboard", label: "Home", icon: Home, color: "#3b82f6" },
    { to: "/schooladmin", label: "School Admin", icon: Users, color: "#ec4899" },
    { to: "/classadmin", label: "Class Admin", icon: BookOpen, color: "#10b981" },
    { to: "/userexistence", label: "User Admin", icon: Search, color: "#06b6d4" },
    { to: "/screenermanagement", label: "Screener Admin", icon: Shield, color: "#ef4444" },
    { to: "/resettasks", label: "Resetting Tasks", icon: RotateCcw, color: "#f59e0b" },
    { to: "/reports", label: "Reports", icon: BarChart3, color: "#8b5cf6" },
    { to: "/aladdinexport", label: "Aladdin Export", icon: Upload, color: "#6366f1" },
    { to: "/productcatalog", label: "Product Catalog", icon: Package, color: "#8b5cf6" },
    { to: "/schoolaccessmanager", label: "School Access Manager", icon: Key, color: "#f97316" },
    // { to: "/trialmanagement", label: "Trial Management", icon: Clock, color: "#14b8a6" },
    // { to: "/purchasemanagement", label: "Purchase Management", icon: CreditCard, color: "#22c55e" },
    { to: "/pilotmanagement", label: "Pilot Management", icon: Plane, color: "#3b82f6" },
    { to: "/schoolmessagingdash", label: "School Messaging", icon: MessageSquare, color: "#a855f7" },
    { to: "/trialtrackerdash", label: "Trial Tracking", icon: CheckSquare, color: "#06b6d4" },
    { to: "/sandboxcontentmanagement", label: "Sandbox Content Management", icon: FileText, color: "#f59e0b" },
    { to: "/bannercontentadmin", label: "Banner Content Admin", icon: Palette, color: "#ec4899" },
    { to: "/visualbannereditor", label: "Banner Editor", icon: Edit3, color: "#14b8a6" },
    { to: "/onboardingtrackerdash", label: "Onboarding Tracking", icon: UserCheck, color: "#84cc16" },
    { to: "/tagmanagement", label: "Tag Management", icon: Tags, color: "#d946ef" },
    { to: "/schoolgroupadmin", label: "School Group Admin", icon: Users, color: "#0ea5e9" },
    { to: "/recommendationsadmin", label: "Recommendations Admin", icon: BookOpen, color: "#10b981" },
    { to: "/messageeditor", label: "Message Editor", icon: Edit3, color: "#f97316" },
    { to: "/customqrgenerator", label: "QR Code Generator", icon: QrCode, color: "#0ea5e9" },
    { to: "/academicyearcontrol", label: "Academic Year Control", icon: CalendarDays, color: "#7c3aed" },
    { to: "/staffaccessmanager", label: "Staff Access", icon: ShieldCheck, color: "#dc2626" }
  ];

  const navItems = teacherMode ? teacherNavItems : allNavItems;

  return (
    <Col sm={2} className={`left-panel ${isCollapsed ? "collapsed" : ""}`}>
      {/* ✅ NEW: Alpaca Logo Section */}
      <div className="panel-logo-section">
        <img 
          src="/assets/imgs/Alpaca-logo-white-outline.png" 
          alt="Alpaca Logo" 
          className={`alpaca-logo ${isCollapsed ? "collapsed" : ""}`}
        />
      </div>

      <div className="panel-header">
        <button 
          className="collapse-toggle"
          onClick={() => setIsCollapsed(!isCollapsed)}
          aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          {isCollapsed ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
        </button>
      </div>

      <nav className="side-nav">
        <ul className="nav-list">
          {teacherMode && (
            <li>
              <a
                href="#"
                className="nav-item return-to-td"
                onClick={handleReturnToTD}
                title={isCollapsed ? "Return to Teacher Dashboard" : ""}
              >
                <ArrowLeft className="nav-icon" size={20} style={{ color: "#4da6bf" }} />
                {!isCollapsed && <span className="nav-label">Back to Teacher Dashboard</span>}
              </a>
            </li>
          )}

          {navItems.map(({ to, label, icon: Icon, color }) => (
            <li key={to}>
              <Link
                to={to}
                className={`nav-item ${activeItem === to ? "active" : ""}`}
                onClick={() => setActiveItem(to)}
                title={isCollapsed ? label : ""}
              >
                <Icon className="nav-icon" size={20} style={{ color }} />
                {!isCollapsed && <span className="nav-label">{label}</span>}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </Col>
  );
}

export default LeftPanel;
